const axios = require('axios').default

export const HTTP = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})
